import * as types from "../actionType";

const initialState = [];

export const userBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_BILLING_DATA:
      return action.payload;
    default:
      return state;
  }
};
